import * as React from 'react'
import classNames from 'classnames'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import YearAndMonthSelects from './YearAndMonthSelects'
import { DATE_FORMAT_PP } from 'utils/constants'
import { formatDate, formatISODate, weekdaysShort } from 'utils/date'
import { FormError, getLabelComponent } from '@conekta/ui-component-library'
import { FROM_LEGAL_MONTH, TO_LEGAL_MONTH } from './constants'
import { IInputDatePicker } from './interface'
import { parseDate } from './helpers'
import { useField } from 'react-final-form'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './InputDatePicker.scss'
import 'react-day-picker/lib/style.css'

const InputDatePicker = ({
  className,
  dateFormat = DATE_FORMAT_PP,
  fromMonth = FROM_LEGAL_MONTH,
  toMonth = TO_LEGAL_MONTH,
  descriptionField,
  fieldsetNoMarginLeft,
  hideError,
  icon,
  input,
  labelComponent,
  labelOptions,
  meta: { active, error, touched },
  placeholder
}: IInputDatePicker) => {
  const [month, setMonth] = React.useState({ month: fromMonth })
  const { i18n } = useTranslation()
  const handleYearMonthChange = (month: any) => setMonth({ month })

  const handleDayChange = (day: Date) => {
    setDaySelected(day)
    input.onChange(formatISODate(day))
  }

  const Label = getLabelComponent(labelComponent)
  const WEEKDAYS: Array<string> = weekdaysShort(i18n.language)
  icon = icon ? icon : 'icon-calendar'

  const [daySelected, setDaySelected] = useState<Date | null>(null)
  const inputValueDate = new Date(daySelected ? daySelected : input.value)
  const inputValueMonth = inputValueDate.getMonth() + 1
  const showSelected = inputValueMonth === month.month?.getMonth() + 1

  return (
    <fieldset
      className={classNames('DayPickerFormat', className, {
        'no-left-margin': fieldsetNoMarginLeft,
        active
      })}
    >
      <Label {...labelOptions} active={active || input.value} error={error && touched}>
        <div
          className={classNames(`DayPickerInput__wrapper${showSelected ? '' : ' DayPickerInput--not_show'}`, {
            error: error && touched
          })}
        >
          <DayPickerInput
            dayPickerProps={{
              captionElement: ({ date }) => (
                <YearAndMonthSelects
                  date={date}
                  fromMonth={fromMonth}
                  toMonth={toMonth}
                  onChange={handleYearMonthChange}
                />
              ),
              disabledDays: {
                after: new Date()
              },
              locale: i18n.language,
              month: month.month,
              weekdaysShort: WEEKDAYS,
              fromMonth: fromMonth,
              toMonth: toMonth
            }}
            inputProps={{
              name: input.name,
              id: input.name,
              placeholder: '',
              readOnly: true
            }}
            format={dateFormat}
            formatDate={formatDate}
            parseDate={parseDate}
            keepFocus={false}
            onDayChange={handleDayChange}
            placeholder={placeholder}
          />
          <i className={classNames('DayPickerInput__wrapper--icon', icon)} />
        </div>
      </Label>
      {descriptionField && <p>{descriptionField.text}</p>}
      {!hideError && <FormError {...{ useField }} {...input} />}
    </fieldset>
  )
}

export default InputDatePicker
